import { Logo } from "../brand/Logo";
import { Mail } from "lucide-react";
import { SITE, LEGAL_CONTACT_EMAIL } from "../../legal/legalContent";

export const PublicFooter = () => (
  <footer className="border-t border-white/10 bg-[#0B0D13]" data-testid="public-footer">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-4 max-w-sm text-sm text-slate-400">
            INDEPENDENT es un software B2B (SaaS) que ayuda a propietarios de pymes a reducir la
            dependencia operativa de personas clave y construir una empresa más delegable.
          </p>
          <a href={`mailto:${LEGAL_CONTACT_EMAIL}`} data-testid="footer-contact-email"
            className="mt-5 inline-flex items-center gap-2 text-sm text-amber-400 hover:text-amber-300">
            <Mail className="h-4 w-4" /> {LEGAL_CONTACT_EMAIL}
          </a>
          <p className="mt-1.5 text-xs text-slate-600">Dominio oficial {SITE.domain}</p>
        </div>

        <div>
          <p className="mono-label text-slate-500">Producto</p>
          <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
            <li><a href="/#producto" className="hover:text-white transition-colors">Qué es</a></li>
            <li><a href="/#como-funciona" className="hover:text-white transition-colors">Cómo funciona</a></li>
            <li><a href="/#precios" className="hover:text-white transition-colors">Precios</a></li>
            <li><a href="/#faq" className="hover:text-white transition-colors">FAQ</a></li>
          </ul>
        </div>

        <div>
          <p className="mono-label text-slate-500">Legal</p>
          <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
            <li><a href="/terms" data-testid="footer-link-terms" className="hover:text-white transition-colors">Términos</a></li>
            <li><a href="/privacy" data-testid="footer-link-privacy" className="hover:text-white transition-colors">Privacidad</a></li>
            <li><a href="/cookies" data-testid="footer-link-cookies" className="hover:text-white transition-colors">Cookies</a></li>
            <li><a href="/legal" data-testid="footer-link-legal" className="hover:text-white transition-colors">Aviso legal</a></li>
            <li><a href="/auth" data-testid="footer-link-login" className="hover:text-white transition-colors">Entrar</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-white/10 pt-6">
        <p className="text-xs text-slate-500">© 2026 INDEPENDENT · Software de independencia operativa para pymes.</p>
        <p className="text-xs text-slate-600 font-mono">Business Independence OS</p>
      </div>
    </div>
  </footer>
);
